/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';
import SelectField from './Select';

import provinces from '../../data/provinces.json';

const propTypes = {
    disabledProvinces: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
    disabledProvinces: null,
};

function ProviceField({ disabledProvinces, ...props }) {
    const { locale, formatMessage } = useIntl();
    const provinceOptions = useMemo(
        () =>
            provinces.map(({ id, name }) => ({
                value: id,
                label: name[locale],
                disabled: disabledProvinces !== null && disabledProvinces.indexOf(id) !== -1,
            })),
        [provinces, locale, disabledProvinces],
    );
    return (
        <SelectField
            placeholder={formatMessage({
                defaultMessage: 'Province / Territory',
                description: 'Field placeholder',
            })}
            items={provinceOptions}
            {...props}
        />
    );
}

ProviceField.propTypes = propTypes;
ProviceField.defaultProps = defaultProps;

export default ProviceField;
